import { Link } from "react-router-dom";
import { FadeIn, MaskedLineScroll, Overline } from "@/components/Reveal";

const COMMUNES = [
  { name: "Champigny-sur-Marne", to: "/couvreur-champigny-sur-marne" },
  { name: "Saint-Maur-des-Fossés", to: "/couvreur-saint-maur-des-fosses" },
  { name: "Nogent-sur-Marne", to: "/couvreur-nogent-sur-marne" },
  { name: "Le Perreux-sur-Marne", to: "/couvreur-le-perreux-sur-marne" },
  { name: "Joinville-le-Pont", to: "/couvreur-joinville-le-pont" },
  { name: "Bry-sur-Marne", to: "/couvreur-bry-sur-marne" },
  { name: "Chennevières-sur-Marne", to: "/couvreur-chennevieres-sur-marne" },
  { name: "Villiers-sur-Marne", to: "/couvreur-villiers-sur-marne" },
  { name: "Le Plessis-Trévise", to: "/couvreur-le-plessis-trevise" },
  { name: "Créteil", to: null }, { name: "Maisons-Alfort", to: null }, { name: "Alfortville", to: null },
  { name: "Vitry-sur-Seine", to: null }, { name: "Ivry-sur-Seine", to: null }, { name: "Choisy-le-Roi", to: null },
  { name: "Thiais", to: null }, { name: "Orly", to: null }, { name: "Sucy-en-Brie", to: null },
  { name: "Boissy-Saint-Léger", to: null }, { name: "Limeil-Brévannes", to: null }, { name: "Bonneuil-sur-Marne", to: null },
  { name: "Valenton", to: null }, { name: "Villeneuve-Saint-Georges", to: null }, { name: "Villejuif", to: null },
  { name: "Cachan", to: null }, { name: "L'Haÿ-les-Roses", to: null }, { name: "Fresnes", to: null },
];

export default function Zones() {
  return (
    <section id="zones" className="bg-bone py-24 md:py-32 border-b border-midnight/10" data-testid="zones-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <Overline>Zones d'intervention</Overline>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
              <MaskedLineScroll>Votre couvreur dans le</MaskedLineScroll>
              <MaskedLineScroll delay={0.12}><span className="text-signal">Val-de-Marne</span> (94)</MaskedLineScroll>
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 space-y-6">
            <FadeIn>
              <p className="text-base md:text-lg text-midnight/70 leading-relaxed">
                Installés à Champigny-sur-Marne, nous intervenons chaque semaine sur les toitures de tout le
                Val-de-Marne. Nos couvreurs se déplacent gratuitement pour diagnostiquer une fuite de toiture,
                réparer des tuiles cassées, rénover une couverture vieillissante ou reprendre une gouttière abîmée.
              </p>
            </FadeIn>
            <FadeIn delay={0.1}>
              <p className="text-base text-midnight/70 leading-relaxed">
                Le long de la Marne — de Saint-Maur-des-Fossés à Joinville-le-Pont en passant par Nogent-sur-Marne
                et Le Perreux-sur-Marne — comme dans tout le sud du département, de Créteil à Vitry-sur-Seine,
                Maisons-Alfort ou Villejuif, vous bénéficiez du même service : déplacement gratuit, devis gratuit
                et un interlocuteur unique pour vos travaux de toiture.
              </p>
            </FadeIn>
            <FadeIn delay={0.15}>
              <Link
                to="/couvreur-94"
                data-testid="zones-seo-link"
                className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-signal border-b border-signal/40 pb-1 hover:border-signal transition-colors duration-300"
              >
                Couvreur dans tout le Val-de-Marne : la page département
              </Link>
            </FadeIn>
          </div>
          <div className="lg:col-span-7">
            <FadeIn delay={0.2}>
              <div className="border border-midnight/10 bg-white p-6 md:p-8" data-testid="communes-index">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-steel mb-6">
                  Index des communes desservies
                </p>
                <ul className="flex flex-wrap gap-x-2 gap-y-2">
                  {COMMUNES.map((c) => (
                    <li key={c.name}>
                      {c.to ? (
                        <Link
                          to={c.to}
                          data-testid={`commune-link-${c.to.slice(1)}`}
                          className="inline-block font-mono text-[11px] uppercase tracking-[0.08em] text-signal border border-signal/40 px-3 py-1.5 hover:bg-signal hover:text-white transition-colors duration-300"
                        >
                          {c.name}
                        </Link>
                      ) : (
                        <span className="inline-block font-mono text-[11px] uppercase tracking-[0.08em] text-midnight/70 border border-midnight/10 px-3 py-1.5 hover:border-signal hover:text-signal transition-colors duration-300">
                          {c.name}
                        </span>
                      )}
                    </li>
                  ))}
                  <li className="font-mono text-[11px] uppercase tracking-[0.08em] text-white bg-midnight px-3 py-1.5">
                    + toutes les communes du 94
                  </li>
                </ul>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}
